import * as report_constants from '../report_constants';
import { Item } from '@webpt/bonfire/dts/components/SortableSelectionList/imp/Models';

export const ledger_full_column_def = report_constants.report_ledger_full_configuration.column_defs;
export const ledger_group_by_charge_column_def = report_constants.report_ledger_group_by_charge_configuration.column_defs;
export const ledger_group_by_visit_column_def = report_constants.report_ledger_group_by_visit_configuration.column_defs;
export const charges_column_def = report_constants.ledger_report_charges_configuration.column_defs;
export const payment_adjustment_column_def = report_constants.ledger_report_payment_adjustment_configuration.column_defs;
export const claims_column_def = report_constants.ledger_report_claims_configuration.column_defs;

export enum report {
    ledger_full = 'ledger_full',
    ledger_by_charge = 'ledger_by_charge',
    ledger_by_visit = 'ledger_by_visit',
    payment_adjustment = 'payment_adjustment',
    charges = 'charges',
    claims = 'claims'
}

interface non_charge_values_groups {
    dos: string;
    not_charge: string[]
}

export const get_no_charge_values = (data) => {
    var response: non_charge_values_groups[] = [];
    var final_list: Record<string, non_charge_values_groups> = {};
    if (data.length > 0) {
        data.map(data => {
            if (isNaN(data.charge_Id)) {
                if (!final_list[data.dos]) {
                    var processed: non_charge_values_groups = { dos: data.dos, not_charge: [] }
                    final_list[data.dos] = processed;
                }

                const group = final_list[data.dos];
                if (group.not_charge.indexOf(data.charge_Id) === -1) {
                    group.not_charge.push(data.charge_Id);
                }
                
            }
        });
    }

    for (const key in final_list) {
        if (Object.prototype.hasOwnProperty.call(final_list, key)) {
            response.push(final_list[key]);
        }
    }
    return response;
}

export const row_data_formatter = (data, report_name) => {
    var column_def;
    switch (report_name) {
        case report.ledger_full:
            column_def = ledger_full_column_def;
            break;
        case report.ledger_by_charge:
            column_def = ledger_group_by_charge_column_def;
            break;
        case report.ledger_by_visit:
            column_def = ledger_group_by_visit_column_def;
            break;
        case report.charges:
            column_def = charges_column_def;
            break;
        case report.payment_adjustment:
            column_def = payment_adjustment_column_def;
            break;
        case report.claims:
            column_def = claims_column_def;
            break;
        default:
    }

    if (report_name == report.ledger_by_charge || report_name == report.ledger_by_visit) {
        var footer_obj = initialize_footer_obj(column_def);
    }

    if (data.length > 0) {
        data.map(row => {
            column_def.map((value, index) => {
                switch (value.type) {
                    case 'date':
                        row[value.field] =
                            row[value.field] != null || row[value.field] != undefined
                                ? report_constants.dateFormatter(row[value.field])
                                : '';
                        break;
                    case 'currency':
                        if (report_name == report.ledger_full || report_name == report.ledger_by_charge || report_name == report.ledger_by_visit) {
                            footer_obj[value.field] += row[value.field] ? parseFloat(row[value.field]) : 0;
                        }
                        row[value.field] =
                            row[value.field] != null || row[value.field] != undefined
                                ? report_constants.currencyFormatter(row[value.field])
                                : (value.allowBlank != null && value.allowBlank != undefined && value.allowBlank == true)
                                    ? ''
                                    : report_constants.currencyFormatter(0);
                        break;
                    case 'number':
                        if (report_name == report.ledger_full || report_name == report.ledger_by_charge || report_name == report.ledger_by_visit) {
                            footer_obj[value.field] += row[value.field] ? parseInt(row[value.field]) : 0;
                        }
                        row[value.field] =
                            row[value.field] != null || row[value.field] != undefined ? parseInt(row[value.field]) : 0;
                        break;
                    case 'boolean':
                        if (report_name == report.ledger_full || report_name == report.ledger_by_charge || report_name == report.ledger_by_visit) {
                            row[value.field] = row[value.field] ? 'Active' : 'Inactive';
                        }
                        break;
                    default:
                        row[value.field] =
                            row[value.field] != null || row[value.field] != undefined
                                ? row[value.field] === row.is_active
                                    ? capitalize_text(row[value.field].toString().trim())
                                    : row[value.field].toString().trim()
                                : '';
                    //value.minWidth = value.minWidth < ((row[value.field].length * 7) + 50) ? ((row[value.field].length * 7) + 50)  : value.minWidth;
                }
            });
            return row;
        });
    }

    if (report_name == report.ledger_by_charge || report_name == report.ledger_by_visit) {
        column_def.map((value, index) => {
            if (value.type == 'currency') {
                footer_obj[value.field] = report_constants.currencyFormatter(footer_obj[value.field]);
            }
        });

    }
    return {
        data: data,
        footer: footer_obj
    };
};

const initialize_footer_obj = column_def => {
    var footer_obj = {};
    column_def.map((value, index) => {
        if (index == 0) {
            footer_obj[value.field] = 'Total';
        } else if (value.type == 'currency' || value.type == 'number') {
            footer_obj[value.field] = 0;
        } else {
            footer_obj[value.field] = null;
        }
    });
    return footer_obj;
};

const capitalize_text = string => {
    return string.charAt(0).toUpperCase() + string.slice(1);
};

export function deepCopy(items: Item[] = []): Item[] {
    return JSON.parse(JSON.stringify(items));
}

export function configureHeaders(column_config_ordered, column_def: any[]) {
    return column_config_ordered
        .map((fieldId) =>
            column_def.find((def) => def.field === fieldId)
        )
        .filter((item) => item);
}

export function getLabelFromId(id: string, column_def: any[]) {
    const column = column_def.find((def) => def.field.toLowerCase() === id.toLowerCase());

    if (!column) {
        console.warn(`Label not found for id: ${id}`);
        return '';
    }

    return column.headerName;
}